module.exports = __webpack_public_path__ + "img/37.b5ac4ae5.jpeg";